import { render, staticRenderFns } from "./CaseTable.vue?vue&type=template&id=c49309fa&scoped=true&"
import script from "./CaseTable.vue?vue&type=script&lang=ts&"
export * from "./CaseTable.vue?vue&type=script&lang=ts&"
import style0 from "./CaseTable.vue?vue&type=style&index=0&id=c49309fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49309fa",
  null
  
)

export default component.exports